
export default {
  props: {
    paymentIcons: {
      type: Array,
      required: true,
    },

    isSmall: {
      type: Boolean,
      default: false,
    },
  },
}
